<forge-linear-progress *ngIf="!isLoaded"></forge-linear-progress>

<ng-container *ngIf="isLoaded">
    <div *ngIf="loadFailed" class="failedSearch forge-typography--heading2">
        <span>{{loadFailedMessage}}</span>
    </div>

    <div *ngIf="!hasItems" fxLayout="row" fxLayoutAlign="center center">
        No Items
    </div>

    <forge-card *ngIf="hasItems" class="no-padding">
        <h2 *ngIf="title" attr.slot="header" class="info-table-card-header">
            {{title}}
        </h2>

        <table mat-table fxFill [dataSource]="tableData" formArrayName="rows">
            <ng-container *ngFor="let column of dataColumns" [matColumnDef]="column">
                <th mat-header-cell *matHeaderCellDef>
                    <div [ngClass]="getColumnClasses(column)" class="tyl-table-head__cell">
                        {{column}}
                    </div>
                </th>

                <td mat-cell *matCellDef="let row">
                    <div *ngIf="!isBoolean(row[column])" fxLayout="row" [ngClass]="getColumnClasses(row[column])" class="tyl-table-body__cell" [attr.telemetry]="row[column].Label">

                        <forge-tooltip *ngIf="row[column].Tooltip" placement="bottom">
                            {{row[column].Tooltip}}
                        </forge-tooltip>

                        <div class="truncated no-wrap" [ngStyle]="getElementStyle(row[column])">
                            {{row[column].Value}}
                        </div>
                    </div>

                    <div *ngIf="isTrue(row[column])" fxLayout="row" fxLayoutAlign="center center">
                        <mat-icon fontIcon="check" class="checkmark">
                        </mat-icon>
                    </div>
                </td>

                <td mat-footer-cell *matFooterCellDef>
                    <div *ngIf="getTotal(column)" [ngClass]="getColumnClasses(column)">
                        <!-- TODO - why are we assuming the column total is always currency -->
                        {{getTotal(column) | currency}}
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="$$commands">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let row">
                    <command-bar [commands]="getCommands(row)"></command-bar>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columns"></tr>
            <tr mat-row *matRowDef="let row; columns: columns"></tr>
            <tr mat-footer-row *matFooterRowDef="columns"></tr>
        </table>
    </forge-card>
</ng-container>
